import { render, staticRenderFns } from "./Workshops.vue?vue&type=template&id=4d43b23e&scoped=true&"
import script from "./Workshops.vue?vue&type=script&lang=js&"
export * from "./Workshops.vue?vue&type=script&lang=js&"
import style0 from "./Workshops.vue?vue&type=style&index=0&id=4d43b23e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d43b23e",
  null
  
)

export default component.exports